module.exports = __webpack_public_path__ + "img/DiversityChecked.8e49ce98.svg";